import React from "react";
import { withRouter, RouteComponentProps } from "react-router";

// import { Link } from "react-router-dom";

import "./styles.scss";

interface IProps extends RouteComponentProps {}

const Layout: React.FC<IProps> = ({ children, location }) => {
  // const [link, setLink] = useState({ to: "", text: "" });

  // useEffect(() => {
  //   if (location.pathname === "/signin")
  //     setLink({ to: "/signup", text: "Зарегистрироваться" });
  //   else setLink({ to: "/signin", text: "Войти" });
  // }, [location.pathname]);

  return (
    <div className="layout">
      <div className="layout__wrapper">
        <div className="layout__header">
          <div className="layout__logo">
            <p className="layout__logo_label">LeDelice admin</p>
          </div>
        </div>
        <div className="layout__form">{children}</div>
        <div className="layout__footer">
          {/* <Link className="layout__link" to={link.to}>
            {link.text}
          </Link> */}
        </div>
      </div>
    </div>
  );
};

export default withRouter(Layout);
